module.exports = __webpack_public_path__ + "static/media/5.d425bda0.jpg";